import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisabled = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 22.769,
	height: 24,
	viewBox: "0 0 22.769 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_2518",
			"data-name": "Path 2518",
			d: "M8.6-23.707A2.8,2.8,0,0,0,5.823-20.92a2.764,2.764,0,0,0,2.162,2.672v7.457a.615.615,0,0,0,.615.615h7.63l3.517,6.448a.615.615,0,0,0,.538.327l2.153-.01a.615.615,0,0,0,.54-.3.615.615,0,0,0,0-.62.615.615,0,0,0-.54-.3l-1.787.01-3.517-6.448a.615.615,0,0,0-.538-.327H9.216v-2.768h6.15a.615.615,0,0,0,.54-.305.615.615,0,0,0,0-.62.615.615,0,0,0-.54-.305H9.216v-2.835a2.75,2.75,0,0,0,2.143-2.681A2.785,2.785,0,0,0,8.6-23.707Zm-.154,1.24a1.508,1.508,0,0,1,.154,0,1.545,1.545,0,0,1,1.547,1.547A1.52,1.52,0,0,1,8.6-19.4,1.512,1.512,0,0,1,7.063-20.92,1.548,1.548,0,0,1,8.447-22.467ZM4.574-14.721a.615.615,0,0,0-.279.087A8.017,8.017,0,0,0,.567-9.772,8.009,8.009,0,0,0,6.227.021,8.009,8.009,0,0,0,16.02-5.64a.617.617,0,0,0-.161-.6.617.617,0,0,0-.6-.159.617.617,0,0,0-.435.437A6.755,6.755,0,0,1,6.544-1.171,6.755,6.755,0,0,1,1.758-9.455,6.775,6.775,0,0,1,4.91-13.568a.615.615,0,0,0,.309-.619.615.615,0,0,0-.463-.515.615.615,0,0,0-.183-.019Z",
			transform: "translate(-0.294 23.707)",
			fill: "#5627d9",
			stroke: "#5627d9",
			strokeWidth: 15
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip-path-2",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Path_2517",
			"data-name": "Path 2517",
			d: "M-1446,1065.48H913.712V-467H-1446Z",
			transform: "translate(1446 467)",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 15
		})
	})] }), /* @__PURE__ */ _jsx("g", {
		id: "Group_9771",
		"data-name": "Group 9771",
		transform: "translate(-0.294 23.707)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Group_902",
			"data-name": "Group 902",
			transform: "translate(0.294 -23.707)",
			clipPath: "url(#clip-path)",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Group_901",
				"data-name": "Group 901",
				transform: "translate(-1482.553 -454.407)",
				clipPath: "url(#clip-path-2)",
				children: /* @__PURE__ */ _jsx("path", {
					id: "Path_2516",
					"data-name": "Path 2516",
					d: "M-4.706-28.707h33.02V5.544H-4.706Z",
					transform: "translate(1482.134 477.988)",
					fill: "currentColor",
					stroke: "currentColor",
					strokeWidth: 15
				})
			})
		})
	})]
});
export default SvgDisabled;
